export default "__VITE_ASSET__BI9lW5jd__"